import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';

import { useFormContext } from '../../contexts';

export function ResetButton({ type = 'reset', variant = 'minimal', isDisabled, ...props }: ButtonProps) {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => ({ isSubmitting: state.isSubmitting, isDirty: state.isDirty })}>
      {({ isSubmitting, isDirty }) => (
        <Button
          isDisabled={isSubmitting || !isDirty || isDisabled}
          variant={variant}
          type={type}
          onPress={() => form.reset()}
          {...props}
        >
          {props.children}
        </Button>
      )}
    </form.Subscribe>
  );
}
